import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import styles from '../../AssociationData.css';
const AssociationDataItem = (props) => {
    const { label, children } = props;
    return (_jsx("div", Object.assign({ className: styles.associationDataItem, "data-testid": "associationDataItem" }, { children: _jsxs("p", Object.assign({ className: styles.associationDataItemContent }, { children: [_jsx("span", Object.assign({ className: styles.associationDataLabel }, { children: label }), void 0), ' ', children] }), void 0) }), void 0));
};
export default memo(AssociationDataItem);
